/* eslint-disable no-template-curly-in-string */
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import { getElementID, getMergedClassNames } from '../../utils/HTMLUtils';
import { CustomButton } from '../CustomButton';
import CancelIcon from '../Icons/CancelIcon';
import styles from './EscolasFieldContratos.scss';
import { openModal } from '../../store/modules/ModalActions';
import { FormLabel, Chip } from '@material-ui/core';
import SnackbarUtils from 'utils/SnackbarUtils';
import SelectSchoolsModalContrato from 'components/SelectSchoolsModal/SelectSchoolsModalContrato';
import { AddIcon } from 'assets/icons/AddIcon';

const rootClassName = styles.rootClassName;

class EscolasFieldContratos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      ...this.state,
      value: newProps.value,
    });
  }

  onRemove = (escolaId) => {
    let escolas = [];
    this.state.value.map((escola, index) => {
      if (escolaId !== escola.idEscola) {
        escolas.push(escola);
      }
      return index;
    });
    this.onChange(escolas);
  };

  onAdd = (escola) => {
    let escolas = [...this.state.value];
    if (
      escolas.filter((escolaMap) => escola.id === escolaMap.idEscola).length ===
      0
    ) {
      escolas.push({
        idEscola: escola.id,
        nome: escola.nome,
        estadoId: escola.estadoId,
        cidadeNome: escola.cidadeNome,
        gestor: false,
      });
    } else {
      SnackbarUtils.enqueueSnackbar({
        message: this.props.languageValues.escolaExistente
          .split('${1}')
          .join(escola.nome),
        options: {
          variant: 'warning',
        },
      });
    }
    this.onChange(escolas);
  };

  onChange = (escolas) => {
    if (this.props.multiple) {
      this.props.onChange(escolas);
    } else {
      this.props.onChange(escolas && escolas.length > 0 ? escolas[0] : null);
    }
  };

  addButtonIsDisabled = () => {
    if (this.props.multiple) {
      return false;
    }
    return this.state.value.length === 0 ? false : true;
  };

  getAddEscolaLabelButton = () => {
    if (this.props.addEscolaLabelButton) {
      return this.props.addEscolaLabelButton;
    }
    return this.props.multiple
      ? this.props.languageValues.addSchoolsButtom
      : this.props.languageValues.addSchoolButtom;
  };

  render() {
    return (
      <>
        <FormLabel disabled={this.props.disabled} error={this.props.error}>
          {this.props.label}
        </FormLabel>
        <div className={rootClassName + '-escolas-tag-container'}>
          {this.state.value.map((escola, index) => {
            return (
              <Chip
                id={getElementID(this.props.id, 'escola-chip-' + index)}
                color={this.props.disabled ? 'default' : 'secondary'}
                label={escola.nome}
                key={index}
                onDelete={
                  this.props.disabled
                    ? null
                    : () => this.onRemove(escola.idEscola)
                }
                deleteIcon={<CancelIcon />}
              />
            );
          })}
          {this.state.value.length === 0 ? (
            <span
              className={getMergedClassNames([
                this.props.error ? rootClassName + '-escola-error' : '',
              ])}
            >
              {this.props.emptyText}
            </span>
          ) : null}
        </div>
        <CustomButton
          id={getElementID(this.props.id, 'find-school')}
          theme='pufvYellow'
          className={rootClassName + '-find-schools-buttom'}
          label={this.getAddEscolaLabelButton()}
          disabled={this.props.disabled || this.addButtonIsDisabled()}
          rightIcon={<AddIcon />}
          onClick={() => {
            this.props.openModal(SelectSchoolsModalContrato, {
              id: this.props.id + '-find-school',
              estadosByCodCoop: this.props.estadosByCodCoop,
              escolasByCodCoop: this.props.escolasByCodCoop,
              selectedCallback: (escola) => {
                this.onAdd(escola);
              },
            });
          }}
        />
      </>
    );
  }
}

EscolasFieldContratos.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(PropTypes.object).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  emptyText: PropTypes.string,
  multiple: PropTypes.bool,
  addEscolaLabelButton: PropTypes.string,
  estadosByCodCoop: PropTypes.string,
  escolasByCodCoop: PropTypes.string,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EscolasFieldContratos);
